import { api } from "@/lib/api";

export const leadsApi = {
    list: (params) => api.get("/leads", { params }).then(r => r.data),
    get: (id) => api.get(`/leads/${id}`).then(r => r.data),
    create: (body) => api.post("/leads", body).then(r => r.data),
    update: (id, body) => api.patch(`/leads/${id}`, body).then(r => r.data),
    remove: (id) => api.delete(`/leads/${id}`).then(r => r.data),
    bulkDelete: (ids) => api.post("/leads/bulk-delete", { lead_ids: ids }).then(r => r.data),
    bulkTag: (ids, tag) => api.post("/leads/bulk-tag", { lead_ids: ids, tag }).then(r => r.data),
    facets: () => api.get("/leads/facets").then(r => r.data),
    seed: (count = 500, force = false) => api.post("/leads/seed", null, { params: { count, force } }).then(r => r.data),
    reveal: (lead_id, field) => api.post("/leads/reveal", { lead_id, field }).then(r => r.data),
    importCsv: (file) => {
        const form = new FormData();
        form.append("file", file);
        return api.post("/leads/import-csv", form, {
            headers: { "Content-Type": "multipart/form-data" },
        }).then(r => r.data);
    },
    importGouvPreview: (body) => api.post("/leads/import-gouv/preview", body).then(r => r.data),
    importGouv: (body) => api.post("/leads/import-gouv", body).then(r => r.data),
    seedGuyane: (limit_per_sector = 30) => api.post(`/leads/seed-guyane?limit_per_sector=${limit_per_sector}`).then(r => r.data),
};

export const aiApi = {
    prospect: (query) => api.post("/ai/prospect", { query }).then(r => r.data),
};

export const segmentsApi = {
    list: () => api.get("/segments").then(r => r.data),
    create: (body) => api.post("/segments", body).then(r => r.data),
    remove: (id) => api.delete(`/segments/${id}`).then(r => r.data),
    leads: (id, params) => api.get(`/segments/${id}/leads`, { params }).then(r => r.data),
};
